const Settings = () => import(/* webpackChunkName: "admin-module" */ './index');
const PriceLists = () => import(/* webpackChunkName: "admin-module" */ './tabs/Pricelists/Pricelists');
const Booking = () => import(/* webpackChunkName: "admin-module" */ './tabs/Booking/LockedDates');
const Services = () => import(/* webpackChunkName: "admin-module" */ './tabs/Services/Services');
const Locations = () => import(/* webpackChunkName: "admin-module" */ './tabs/Locations/Locations');
const Promocodes = () => import(/* webpackChunkName: "admin-module" */ './tabs/Promocodes/Promocodes');
const PromocodesShow = () => import(/* webpackChunkName: "admin-module" */ './tabs/Promocodes/views/Show');
const Additions = () => import(/* webpackChunkName: "admin-module" */ './tabs/Additions/Additions');
const AdditionsShow = () => import(/* webpackChunkName: "admin-module" */ './tabs/Additions/views/Show');
const MakesModels = () => import(/* webpackChunkName: "admin-module" */ './tabs/MakesModels/MakesModels');
const VehicleGroups = () => import(/* webpackChunkName: "admin-module" */ './tabs/VehicleGroups/Groups');
const PublicPages = () => import(/* webpackChunkName: "admin-module" */ './tabs/PublicPages/Pages');

export default [
    {
        path: 'settings',
        components: { base: Settings },
        children: [
            {
                path: '',
                name: 'pricelists',
                components: { settings: PriceLists }
            },
            {
                path: 'booking',
                name: 'booking',
                components: { settings: Booking }
            },
            {
                path: 'services',
                name: 'services',
                components: { settings: Services }
            },
            {
                path: 'locations',
                name: 'locations',
                components: { settings: Locations }
            },
            {
                path: 'promocodes',
                name: 'promocodes',
                components: { settings: Promocodes }
            },
            {
                path: ':promocode_id/show',
                name: 'promocodes.show',
                components: { settings: PromocodesShow }
            },
            {
                path: 'additions',
                name: 'additions',
                components: { settings: Additions }
            },
            {
                path: ':addition_id/show',
                name: 'additions.show',
                components: { settings: AdditionsShow }
            },
            {
                path: 'makes-models',
                name: 'makes.models',
                components: { settings: MakesModels }
            },
            {
                path: 'vehicle-groups',
                name: 'vehicle.groups',
                components: { settings: VehicleGroups }
            },
            {
                path: 'public-pages',
                name: 'public.pages',
                components: { settings: PublicPages }
            },
        ]
    },
];
